import { type CSSProperties } from "react";
import { Tooltip, type InputProps } from "antd";
import clsx from "clsx";
import { InfoIcon } from "@/shared/assets/svg/icons";
import { InputSearch } from "../input-search";
import "./input-search-with-info.scss";

interface IInputSearchWithInfo extends Omit<InputProps, "placeholder"> {
  tooltipTitle: string;
  className?: string;
  style?: CSSProperties;
}

export const InputSearchWithInfo = ({
  tooltipTitle,
  className,
  style,
  ...rest
}: IInputSearchWithInfo) => {
  return (
    <div className={clsx("input-search-with-info", className)}>
      <InputSearch placeholder="Поиск" style={style} {...rest} />
      <Tooltip title={tooltipTitle} placement="top" arrow={false}>
        <span className="input-search-with-info__icon">
          <InfoIcon />
        </span>
      </Tooltip>
    </div>
  );
};
